var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelegatedNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6c63fb;}.b{fill:#fff;}.c{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H40L0,40Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.001 4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,8.8V7.85a4,4,0,0,1,8,0V8.8ZM1.6,1.4A2.4,2.4,0,1,1,4,3.8,2.4,2.4,0,0,1,1.6,1.4Z",
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 16,
    height: 16
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelegatedNotification);
export default __webpack_public_path__ + "static/media/delegatedNotification.8165adaade1898255d48133558c7a91b.svg";
export { ForwardRef as ReactComponent };